/**
 * Created by mnaughton on 10/20/2015.
 */

import FileView from "core/views/Field/view/FileView";
import _ from "underscore";
export default FileView.extend({
  template: _.template(
    '<img src="<%-url%>" data-value="<%-value%>" alt="No File Found."/>'
  ),
  className: "panel panel-default image-panel",

  getControlValue: function () {
    return this.$("img").data("value");
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/view/ImageView.js
// module id = 849
// module chunks = 1